import { ApiCallStatus } from '../../services/api-call-status';
import { RootState } from '../../store';
import { Episode } from './slice';

export const selectIsEpisodesLoading = (state: RootState): boolean => state.episodes.status === ApiCallStatus.loading;
export const selectEpisodes = (state: RootState): Episode[] => state.episodes.data;
